import { EnumTDAEStatus } from '@blank/api'
import { useAuthenticatedUserCorporateQuery } from 'modules/auth/queries/useAuthenticatedUserCorporateQuery'
import { useCallback } from 'react'
import { useFetchTDAEInformation } from './useFetchTDAEInformation'

export const useCheckTDAEServiceSubscription = () => {
  const {
    data: { corporate },
    isLoading: isCorporateInformationLoading,
    isError: isCorporateInformationError,
    errorRefetch: corporateInformationErrorRefetch,
  } = useAuthenticatedUserCorporateQuery()

  const {
    tdaeInformation,
    tdaeInformationError,
    isFetchTDAEInformationLoading,
    isFetchTDAEInformationError,
    errorRefetch: fetchTDAEInformationErrorRefetch,
  } = useFetchTDAEInformation()

  const canAccessTdaeUrssafService = corporate?.features?.isUrssafTDAEEligible

  const isTDAEInformationNotFoundError =
    tdaeInformationError?.response?.data?.error?.message ===
    'corporate_tdae_information_not_found'

  const isTDAEServiceNeverSubscribed =
    !tdaeInformation?.status ||
    tdaeInformation?.status === EnumTDAEStatus.UNDEFINED

  const isLoading =
    isCorporateInformationLoading || isFetchTDAEInformationLoading

  const isCheckError =
    isCorporateInformationError ||
    (isFetchTDAEInformationError && !isTDAEInformationNotFoundError)

  const errorRefetch = useCallback(() => {
    if (isCorporateInformationError) {
      corporateInformationErrorRefetch()
    }
    if (isFetchTDAEInformationError) {
      fetchTDAEInformationErrorRefetch()
    }
  }, [
    corporateInformationErrorRefetch,
    fetchTDAEInformationErrorRefetch,
    isCorporateInformationError,
    isFetchTDAEInformationError,
  ])

  return {
    canAccessTdaeUrssafService,
    isLoading,
    isCheckError,
    isCheckSuccess: !isLoading && !isCheckError,
    isTDAEServiceNeverSubscribed,
    tdaeInformation,
    errorRefetch,
  }
}
